import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  supplementaryVivaRemoved,
  removeBasicInsuranceForPerson,
  changeBasicInsuranceForPerson,
  changeBasicInsuranceForPersonIntent,
  removeBasicInsuranceForPersonIntent,
} from './actions';
import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { getOfferState } from '../offer.selector';

@Injectable()
export class BasicInsuranceEffects {
  public processBasicInsuranceIntents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(removeBasicInsuranceForPersonIntent, changeBasicInsuranceForPersonIntent),
      withLatestFrom(this.store.select(getOfferState)),
      mergeMap(([action, offerState]) => {
        const person = offerState.persons.find((p) => p.personId === action.personId);
        const hasViva =
          person?.supplementaryInsurances?.complementaryViva ||
          person?.supplementaryInsurances?.outpatientViva ||
          person?.supplementaryInsurances?.hospitalViva;

        const actionsToDispatch = [];

        if (hasViva) {
          actionsToDispatch.push(supplementaryVivaRemoved({ personId: action.personId }));
        }

        if (action.type === removeBasicInsuranceForPersonIntent.type) {
          actionsToDispatch.push(removeBasicInsuranceForPerson({ personId: action.personId }));
        } else if (action.type === changeBasicInsuranceForPersonIntent.type) {
          actionsToDispatch.push(
            changeBasicInsuranceForPerson({
              personId: action.personId,
              basicInsuranceKey: action.basicInsuranceKey,
              franchise: action.franchise,
              includesAccidentCoverage: action.includesAccidentCoverage,
              medicalOffice: action.medicalOffice,
            }),
          );
        }

        return actionsToDispatch;
      }),
    ),
  );
  constructor(
    private actions$: Actions,
    private store: Store,
  ) {}
}
